import { render, staticRenderFns } from "./nocontainer.vue?vue&type=template&id=6d2e9f7f&scoped=true&"
import script from "./nocontainer.vue?vue&type=script&lang=js&"
export * from "./nocontainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2e9f7f",
  null
  
)

export default component.exports